import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  page: {
    width: '100%'
  },

  countChip: {
    display: 'inline-flex',
    alignItems: 'center',
    height: 22,
    padding: '0 8px',
    borderRadius: 999,
    background: token.colorFillTertiary,
    color: token.colorTextSecondary,
    fontSize: token.fontSizeSM,
    fontWeight: 500,
    fontFeatureSettings: '"tnum"',
    lineHeight: 1
  },

  searchInput: {
    maxWidth: 480,
    background: token.colorBgContainer
  },

  empty: {
    padding: `${token.paddingXL}px 0`,
    borderRadius: token.borderRadiusLG,
    border: `1px dashed ${token.colorBorderSecondary}`,
    background: token.colorBgContainer
  }
}))
